import { render } from "./mathjaxContent.vue?vue&type=template&id=73d04a6c"
import script from "./mathjaxContent.vue?vue&type=script&lang=js"
export * from "./mathjaxContent.vue?vue&type=script&lang=js"

import "./mathjaxContent.vue?vue&type=style&index=0&id=73d04a6c&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__